import { logDiagnosticoBonificacionNocturna } from './bonificacionNocturnaPlanilla';

const CODIGO_PLAME_BONIFICACION_NOCTURNA = '0309';
const FACTOR_TASA_NOCTURNA = 0.35;
const DIAS_MES = 30;
const HORAS_JORNADA = 8;

export function esTareoConTasaNocturna(tareo) {
  const valor = tareo?.considerar_tasa_nocturna;
  if (valor === true || valor === 1) return true;
  if (valor === false || valor === 0 || valor == null) return false;
  const normalizado = String(valor).trim().toLowerCase();
  return normalizado === 'true' || normalizado === '1' || normalizado === 'si' || normalizado === 's';
}

export function buscarConceptoBonificacionNocturna(conceptosPlame = []) {
  const lista = Array.isArray(conceptosPlame) ? conceptosPlame : Object.values(conceptosPlame || {});

  const porCodigo = lista.find(
    (c) => String(c.codigo_plame || c.codigo || '') === CODIGO_PLAME_BONIFICACION_NOCTURNA
  );
  if (porCodigo) return porCodigo;

  const porDescripcion = lista.find((c) => {
    const desc = String(c.descripcion || c.nombre || '').toUpperCase();
    return desc.includes('NOCTURN') && desc.includes('BONIFIC');
  });
  if (porDescripcion) return porDescripcion;

  return (
    lista.find((c) => String(c.descripcion || c.nombre || '').toUpperCase().includes('NOCTURN')) || null
  );
}

export function calcularTasaNocturnaEmpleado({
  tareos = [],
  remuneracionBasica = 0,
  configuracionTasaNocturna = null,
  conceptosPlame = [],
}) {
  const conceptoPlame = buscarConceptoBonificacionNocturna(conceptosPlame);
  const activoConfig = Boolean(configuracionTasaNocturna?.activo);
  const calcularEnPlanilla = configuracionTasaNocturna?.calcular_en_planilla !== false;
  const aplicarEnPlanilla = activoConfig && calcularEnPlanilla;
  const horasPorDia = parseFloat(configuracionTasaNocturna?.horas_tasa_nocturna ?? 0);
  const dias = (tareos || []).filter(esTareoConTasaNocturna).length;
  const sueldo = parseFloat(remuneracionBasica) || 0;

  const baseVacia = {
    activo: false,
    calcularEnPlanilla,
    dias,
    horasPorDia: horasPorDia || 0,
    horasTotales: 0,
    montoPorDia: 0,
    montoTotal: 0,
    valorHora: 0,
    montoPorHoraNocturna: 0,
    remuneracionBasica: sueldo,
    conceptoPlame,
  };

  const motivoNoCalcula = !aplicarEnPlanilla
    ? (!activoConfig
        ? 'config.activo=false'
        : !calcularEnPlanilla
          ? 'calcular_en_planilla=false'
          : 'aplicarEnPlanilla=false')
    : sueldo <= 0
      ? 'remuneracionBasica<=0'
      : !horasPorDia || horasPorDia <= 0
        ? 'horas_tasa_nocturna invalidas'
        : dias === 0
          ? '0 tareos con considerar_tasa_nocturna'
          : null;

  if (!aplicarEnPlanilla || sueldo <= 0 || !horasPorDia || horasPorDia <= 0 || dias === 0) {
    logDiagnosticoBonificacionNocturna('calcularTasaNocturnaEmpleado → NO calcula', {
      configuracionTasaNocturna,
      activoConfig,
      calcularEnPlanilla,
      aplicarEnPlanilla,
      remuneracionBasica: sueldo,
      horasPorDia,
      dias_tareos_nocturnos: dias,
      motivo: motivoNoCalcula,
      resultado: baseVacia,
    });
    return baseVacia;
  }

  const valorHora = sueldo / DIAS_MES / HORAS_JORNADA;
  const montoPorHoraNocturna = valorHora * FACTOR_TASA_NOCTURNA;
  const montoPorDia = parseFloat((montoPorHoraNocturna * horasPorDia).toFixed(2));
  const horasTotales = parseFloat((horasPorDia * dias).toFixed(2));
  const montoTotal = parseFloat((montoPorDia * dias).toFixed(2));

  const resultado = {
    activo: true,
    calcularEnPlanilla: true,
    dias,
    horasPorDia,
    horasTotales,
    montoPorDia,
    montoTotal,
    valorHora: parseFloat(valorHora.toFixed(4)),
    montoPorHoraNocturna: parseFloat(montoPorHoraNocturna.toFixed(4)),
    remuneracionBasica: sueldo,
    conceptoPlame,
  };

  logDiagnosticoBonificacionNocturna('calcularTasaNocturnaEmpleado → SÍ calcula', {
    configuracionTasaNocturna,
    formula: '(sueldo/30/8)*0.35*horas*dias',
    remuneracionBasica: sueldo,
    horasPorDia,
    dias,
    montoPorDia,
    montoTotal,
    resultado,
  });

  return resultado;
}
